export const CART_TOKEN = 'CART_TOKEN';